<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="eligibleCampaign" class="bg-content" data-testid="gamification-home-page">
    <div style="max-width: 480px" class="z-10">
      <BlNavBarMv
        class="top-0 w-full"
        has-back-button
        background-color="none"
        data-testid="navbar"
        title="Ambil hadiah misi"
        @handleBackButtonClick="onClickBack"
      />
    </div>
    <div class="ph-24 mt-48">
      <div class="bg-white rounded-2xl p-16 content-height" data-testid="claim-details">
        <div v-if="currentStep === 1">
          <div>
            <BlTextAv color="subdued" variation="caption-12">1 dari 2</BlTextAv>
            <BlTextAv weight="bold" variation="subheading-18" class="mt-4">Isi info akun e-wallet</BlTextAv>
          </div>
          <BlCalloutMv class="mt-16" variation="medium">Pastikan info sudah benar agar hadiah bisa kamu terima.</BlCalloutMv>

          <div class="mt-16">
            <BlTextAv weight="bold" variation="subheading-18">E-wallet</BlTextAv>
            <div class="c-wallet" @click="onUpdateShowWalletList(true)">
              <div class="flex items-center gap-4">
                <img :src="$publicUrl(`images/kartu-prakerja/wallet/${walletValue.icon}`)" height="28" width="28" :alt="walletValue.icon" />
                <BlTextAv variation="body-14">{{ walletValue.name }}</BlTextAv>
              </div>
              <IcoChevronRightMinor color="#2E2E2E" />
            </div>
          </div>

          <div class="mt-16">
            <BlTextAv weight="bold" variation="subheading-18">No. HP akun e-wallet</BlTextAv>
            <div class="flex mt-4 gap-4">
              <BlFieldMv class="w-full" :error="isPhoneNumberError" :message="{error: phoneNumberErrMessage}">
                <BlTextfieldAv
                  v-model="phoneNumber"
                  placeholder="Masukkan no. HP"
                  data-testid="phone-input"
                  clearable
                  @keydown="inputNumberOnly"
                />
              </BlFieldMv>
              <BlButtonAv
                variation="secondary"
                :disabled="phoneNumber.length === 0 || isLoadingCheckPhoneNumber"
                :is-loading="isLoadingCheckPhoneNumber"
                data-testid="inquiry-cek-button"
                @click="onCheckPhoneNumber"
              >
                Cek
              </BlButtonAv>
            </div>
          </div>
          <BlSeparatorAv class="mt-16 mb-16" />

          <div v-if="isLoadingCheckPhoneNumber" class="c-account flex flex-col gap-4">
            <BlShimmerAv width="120px" height="16px" style="border-radius: 4px" />
            <BlShimmerAv width="160px" height="16px" style="border-radius: 4px" />
          </div>

          <div v-if="!isPhoneNumberError && customerName !== ''" class="c-account">
            <BlTextAv variation="caption-12">Nama pemilik akun</BlTextAv>
            <BlTextAv weight="bold" variation="body-16" class="mt-8" data-testid="customer-name">{{ customerName }}</BlTextAv>
          </div>
          <BlButtonAv
            class="btn-blue mt-16 mb-16"
            data-testid="btn-lanjutkan"
            fullwidth
            :disabled="!isEnableNextStep"
            @click="currentStep = 2"
          >
            Lanjutkan
          </BlButtonAv>
        </div>
        <div v-if="currentStep === 2">
          <div>
            <BlTextAv color="subdued" variation="caption-12">2 dari 2</BlTextAv>
            <BlTextAv weight="bold" variation="subheading-18" class="mt-4">Isi testimoni tentang Prakerja</BlTextAv>
          </div>

          <div class="mt-16">
            <div class="mt-4 gap-4">
              <BlFieldMv :error="isReviewError">
                <BlTextareaAv
                  v-model="review"
                  placeholder="Masukkan testimoni kamu"
                  data-testid="review-input"
                  :is-show-counter="false"
                  class="c-text-area"
                />
              </BlFieldMv>
              <div class="flex justify-between">
                <BlTextAv :color="isReviewError && 'error-01'" variation="caption-12">Min. 300 karakter</BlTextAv>
                <BlTextAv variation="caption-12">{{ review.length }}</BlTextAv>
              </div>
            </div>
          </div>
          <BlSeparatorAv class="mt-16 mb-16" />
          <BlButtonAv class="btn-blue mt-16 mb-16" data-testid="btn-simpan" fullwidth @click="onSubmit">Simpan</BlButtonAv>
        </div>
      </div>
    </div>
    <GamificationWalletList
      :is-show-wallet-list="isShowWalletList"
      @onUpdateShowModal="onUpdateShowWalletList"
      @onWalletClick="onWalletClick"
    />
    <GamificationSuccessClaim v-if="isShowSuccessClaim" :is-show-success-claim="isShowSuccessClaim" />
  </div>
</template>

<script>
import {
  BlButtonAv,
  BlTextAv,
  BlSeparatorAv,
  BlNavBarMv,
  BlCalloutMv,
  BlTextfieldAv,
  BlTextareaAv,
  BlFieldMv,
  BlShimmerAv,
} from '@bukalapak/bazaar-mweb-latest';
import GamificationWalletList from '../components/GamificationWalletList/GamificationWalletList.vue';
import GamificationSuccessClaim from '../components/GamificationSuccessClaim/GamificationSuccessClaim.vue';
import {IcoChevronRightMinor} from '@bukalapak/bazaar-visual-next';
import moment from 'moment';
moment.locale('id');

export default {
  name: 'PrakerjaGamificationClaimPage',
  components: {
    BlButtonAv,
    BlTextAv,
    IcoChevronRightMinor,
    BlSeparatorAv,
    BlNavBarMv,
    BlCalloutMv,
    BlTextfieldAv,
    BlTextareaAv,
    BlFieldMv,
    BlShimmerAv,
    GamificationWalletList,
    GamificationSuccessClaim,
  },
  data() {
    return {
      getPreviousPage: this.$route.query,
      eligibleCampaign: null,
      phoneNumber: '',
      isPhoneNumberError: false,
      customerName: '',
      review: '',
      isReviewError: false,
      walletValue: {
        id: 'ovo',
        name: 'OVO',
        icon: 'ovo.webp',
      },
      isShowWalletList: false,
      currentStep: 1,
      isShowSuccessClaim: false,
      isEnableNextStep: false,
      isLoadingCheckPhoneNumber: false,
      phoneNumberErrMessage: '',
    };
  },
  computed: {
    isLoggedIn() {
      return !!window.USER?.id;
    },
  },
  watch: {
    review(next) {
      this.isReviewError = next.length === 0;
    },
    phoneNumber() {
      this.isPhoneNumberError = false;
      this.isEnableNextStep = false;
      this.customerName = '';
    },
  },
  beforeMount() {
    if (!this.isLoggedIn) {
      const {isAndroid, isWebview} = window.USER?.agent ?? {};
      const prefixHost = isAndroid || !isWebview ? window.location.origin : '';
      const encodedComebackUrl = window.encodeURIComponent(`${prefixHost}${process.env.BASE_PATH}/gamification`);
      window.location.replace(`${prefixHost}/login?comeback=${encodedComebackUrl}`);
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      try {
        const response = await this.$api.getPrakerjaGamificationEligibleCampaign();
        if (!response.data || response.data?.state !== 'active') {
          this.$router.replace({path: '/'});
          return;
        }

        const isCompletedMission = response.data.missions.some(
          (mission) => mission.id == this.$route.params.missionId && mission.milestone?.state === 'completed'
        );

        if (!isCompletedMission) {
          this.$router.go(-1);
          return;
        }
        this.eligibleCampaign = response.data;
      } catch (error) {
        this.$router.replace({path: '/'});
      }
    },
    onClickBack() {
      if (this.currentStep === 2) {
        this.currentStep = 1;
        return;
      }
      this.$router.go(-1);
    },
    onUpdateShowWalletList(value) {
      this.isShowWalletList = value;
    },
    onWalletClick(wallet) {
      this.walletValue = wallet;
      this.onUpdateShowWalletList(false);
    },
    inputNumberOnly(event) {
      if (!/^\d$/.test(event.key) && event.key !== 'Backspace' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
        event.preventDefault();
      }
    },
    async onCheckPhoneNumber() {
      if (this.phoneNumber.length > 0) {
        this.isLoadingCheckPhoneNumber = true;
        await this.$api
          .getPrakerjaGamificationWalletInquiry({
            mission_id: this.$route.params.missionId,
            phone_number: this.phoneNumber,
            wallet_channel: this.walletValue.id,
          })
          .then((response) => {
            this.customerName = response.data.customer_name;
            this.isEnableNextStep = true;
          })
          .catch((err) => {
            this.isPhoneNumberError = true;
            this.isEnableNextStep = false;
            if (err.meta.http_status === 422) {
              this.phoneNumberErrMessage = 'Akun tidak ditemukan';
              return;
            }
            this.phoneNumberErrMessage = 'Terjadi kesalahan, silakan coba lagi';
          });
        this.isLoadingCheckPhoneNumber = false;
      }
    },
    async onSubmit() {
      this.isReviewError = this.review.length < 300;
      if (!this.isReviewError) {
        await this.$api
          .claimPrakerjaGamificationMission({
            id: this.$route.params.missionId,
            wallet_channel: this.walletValue.id,
            phone_number: this.phoneNumber,
            testimony: this.review,
          })
          .then(() => {
            this.isShowSuccessClaim = true;
          })
          .catch(() => {
            this.$store.dispatch('onSnackbarShow', {error: 'Gagal claim hadiah, silakan coba lagi'});
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-content {
  background: linear-gradient(177.81deg, #006ad3 1.84%, #479fec 42.86%, #1269a7 86.41%);
  min-height: 100vh;

  &::v-deep {
    .bl-nav-bar {
      z-index: 100;
      p {
        color: #fff;
        text-align: center;
      }
      svg path {
        fill: #fff;
      }
    }
  }
}

.content-height {
  min-height: calc(100vh - 420px);
}

.c-wallet {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-top: 4px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.c-account {
  padding: 12px;
  border-radius: 8px;
  background: #ebf2fa;
}

.c-text-area {
  margin-bottom: 16px;
  width: 100%;
  &::v-deep {
    .bl-textarea__inner {
      height: 224px;
      resize: none;
    }
  }
}

.btn-blue {
  background: #332f9e;
  border-radius: 100px;
  border: 2px solid #332f9e;
}
.btn-blue:active {
  background: #4743c9;
  border-color: #4743c9;
}
.btn-blue:hover {
  background: #4743c9;
  border-color: #4743c9;
}
</style>
